
import { useState, useEffect } from 'react';
import { Business } from '@/data/types/businessTypes';

export const useBusinessBillingState = (business: Business | null) => {
  // Initialize with empty arrays and default values
  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
  const [invoices, setInvoices] = useState<any[]>([]);
  const [promoCodes, setPromoCodes] = useState<any[]>([]);
  const [billingManager, setBillingManager] = useState<any>(null);
  const [showSearch, setShowSearch] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>('');
  const [totalCharge, setTotalCharge] = useState<number>(0);
  const [discountCodes, setDiscountCodes] = useState<any[]>([]);
  const [billingHistory, setBillingHistory] = useState<any[]>([]);
  
  // Mock billing data for now - in a real app, this would be fetched from a database
  useEffect(() => {
    if (business) {
      // Here we'd normally fetch real data from the business
      setPaymentMethods([]);
      setInvoices([]);
      setPromoCodes([]);
      setBillingManager(null);
      setTotalCharge(0);
      setDiscountCodes([]);
      setBillingHistory([]);
    }
  }, [business]);
  
  const handleChangeBillingManager = () => {
    console.log('Change billing manager');
  };
  
  const handleAddPaymentMethod = () => {
    console.log('Add payment method');
  };
  
  const handleAddPromoCode = () => {
    console.log('Add promo code');
  };
  
  const handleMakePrimary = (id: string) => {
    console.log('Make payment method primary', id);
    setSelectedPaymentMethod(id);
  };
  
  // Compile all billing data in a single object
  const billingData = {
    paymentMethods,
    nextChargeDate: new Date(),
    invoices,
    billingManager,
    promoCodes,
    // Additional properties for the required interface
    activeBusinesses: [],
    pausedBusinesses: [],
    managedBudgets: [],
    availableCredits: 0,
    promotionalDiscount: 0,
    totalCharge: totalCharge,
    discountCodes: discountCodes,
    billingHistory: billingHistory
  };
  
  return {
    billingData,
    showSearch,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    totalCharge,
    handleChangeBillingManager,
    handleAddPaymentMethod,
    handleAddPromoCode,
    handleMakePrimary
  };
};
